import React, { useState } from "react";
import { deleteField } from "firebase/firestore";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import useUpdatePromise from "hooks/promises/useUpdatePromise";

const FinishButton = ({ promise }) => {
  const [open, setOpen] = useState(false);
  const { updatePromise } = useUpdatePromise();

  const givenTime = new Date(promise.deadline);
  const now = new Date();
  const isPast = givenTime < now;

  return (
    <div className="flex justify-center">
      <div className="flex flex-col gap-2 text-center w-full">
        {!isPast && promise.type !== "finished" && (
          <span className="text-[12px] font-[700] text-gray-600">
            Ժամանակից շուտ`
          </span>
        )}
        <Button
          color={promise.type === "finished" ? "success" : "error"}
          variant="contained"
          className="w-full text-[12px] rounded-[24px]"
          onClick={() => {
            setOpen(true);
          }}
        >
          {promise.type === "finished" ? "Ավարտված է" : "Ավարտել"}
        </Button>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{promise.title}</DialogTitle>
        <DialogContent dividers>
          <div className="flex flex-col gap-[24px] p-[24px]">
            <span className="text-[#212121] text-[12px] line-clamp-6">
              {promise.description}
            </span>
            <div className="flex gap-6">
              <Button
                color="success"
                variant="contained"
                className="w-fit rounded-[24px]"
                onClick={() => {
                  updatePromise(promise.id, {
                    type: "finished",
                    result: true,
                  });
                  setOpen(false);
                }}
              >
                Կանխատեսումը Ճիշտ էր
              </Button>
              <Button
                color="error"
                variant="contained"
                className="w-fit rounded-[24px]"
                onClick={() => {
                  updatePromise(promise.id, {
                    type: "finished",
                    result: false,
                  });
                  setOpen(false);
                }}
              >
                Կանխատեսումը սխալ էր
              </Button>
              <Button
                color="warning"
                variant="contained"
                className="w-fit rounded-[24px]"
                onClick={() => {
                  updatePromise(promise.id, {
                    type: "pending",
                    result: deleteField(),
                  });
                  setOpen(false);
                }}
              >
                Չեղարկել արդյունքը
              </Button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpen(false)}>
            Փակել
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FinishButton;
